import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

// Tres variantes, duas alturas (handoff vitrine-ui.css .btn). "outline" e
// "link" sao aliases de compat pra nao quebrar chamadores existentes que
// ainda nao migraram (secondary === outline visualmente: borda + fundo card).
export type ButtonVariant = "primary" | "secondary" | "ghost" | "outline" | "destructive" | "link" | "ok";
export type ButtonSize = "sm" | "md" | "lg" | "icon";

const variantClass: Record<ButtonVariant, string> = {
  primary: "btn--primary",
  secondary: "btn--secondary",
  outline: "btn--secondary",
  ghost: "btn--ghost",
  destructive: "btn--danger",
  ok: "btn--ok",
  link: "btn--ghost",
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "primary", size = "md", className, loading, disabled, children, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={cn(
        "btn",
        variantClass[variant],
        // Handoff: "tres variantes, duas alturas, nao invente outras". sm/lg
        // eram utilitarios Tailwind (text-sm/px-6) que vencem o .btn por
        // @layer e tiravam 36 botoes da escala; hoje sao alias de md.
        size === "icon" && "btn--icon",
        className,
      )}
      {...rest}
    >
      {loading ? (
        <span
          className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent"
          aria-hidden
        />
      ) : null}
      {children}
    </button>
  );
});
